module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H")])]), _vm._v("e was alone on the beach.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d hoped he would be. But despite the fact that it was almost midnight and officially one day into autumn, because this was Southern California, there was always a chance that a pair of lovers would be out, making use of the solitude.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Either a pair of lovers or a homeless person, seeking a little uninterrupted sleep on one of the benches that outlined a portion of Laguna Beach.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Half beach, half park, with a carefully crafted pseudo-Mediterranean backdrop in the distance, this particular section offered the best of both worlds, which was why, when he’d decided to finally take the plunge and open up his own restaurant, Trevor Marlowe had chosen this area for his locale.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The windows of his restaurant, Kate’s Kitchen, looked out onto the sea. There were times when he thought his patrons came as much for the view of the Pacific as they did for the cuisine, but Kate, his stepmother and the restaurant’s namesake, was quick to set him straight. She insisted that he cooked rings around anyone she knew. Considering he had acquired his love of cooking and learned to create culinary magic from her, Kate’s words were high praise indeed.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that Kate was actually capable of saying anything even remotely negative, he thought now with a smile. Hurting feelings just wasn’t in her nature; it never had been.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate Llewellyn Marlowe was kind. Kind, loving and nurturing, with just enough feistiness to prevent her from being sweetly dull. She kept things around her constantly moving. It was she who encouraged him to follow his dream, she who slipped him money on those occasions when he was short so that he could go on to that culinary academy in Italy. She’d supported him as he perfected skills that were already considerable.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kate had turned out to be the best influence in all their lives—his, his three brothers’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" his father’s. He’d hate to think where all of them would be today if his harried father hadn’t stumbled across Kate, armed with puppets, working a children’s party. According to the story, his father had instantly sensed that this was the woman who could handle his overenergized brood.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He and his brothers had been a handful, acting out, mostly because of their bereavement over the recent death of their mother. There was no telling where he, Mike, Trent and Travis might have wound up had there been no Kate. Possibly juvenile hall.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But, thank God, Kate had come into their lives, bringing sunshine and patient understanding as well as her puppets.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now Trevor believed that all of them would have been lost without her.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had that really been twenty years ago? he marveled. It hardly seemed that long.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One long wave made it out farther than its brethren, soaking his bare feet before receding. He felt the sand eroding beneath his soles, the water symbolically trying to draw him as it retreated to the ocean.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d better start heading back, Trevor thought, though he made no immediate effort to turn around. He allotted himself a couple more minutes. He really did need to unwind. It had been a long, hard week and the weekend hadn’t even arrived yet.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From where he stood, tomorrow wasn’t overly promising. Without anyone calling in sick, he was already short one set of hands. That meant double duty for him until he could get a temp agency to send him a replacement for his salad girl. Thinking of the incident caused him to frown.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His previous salad girl, Ava, had quit, not because of any problems at work but because her boyfriend, a biker whose upper torso was all but covered with tattoos, wanted to go on a two-month road trip. Ava couldn’t bear the idea of being without him for so long. So, amid profuse apologies this afternoon, she’d removed her apron and then just taken off.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he’d handle it, Trevor thought. Somehow, he always did. Kate’s influence had taught him that he could do anything if he set his mind to it.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sighed. Sometimes the credo was harder to live by. Which was why he was out here now, after closing time, walking off some steam and maybe just a small amount of anxiety.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor waited for the calm to come. It was obviously taking its time.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He realized that he’d stopped moving and stared out into the endless ocean. The full moon drew a long, almost white streak along the water. It trailed along like the tail of a kite. The night was so quiet, he could almost hear his thoughts forming.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The only thing that broke the sound of the crashing waves was the occasional cry of a passing seagull.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Here and there, he saw the gulls spreading their wings as they hurried to desert the beach, flying inland to seek shelter.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a storm coming.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How about that, the weatherman might actually be right for a change, Trevor mused.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He vaguely recalled hearing a prediction of rain hitting the coast by tomorrow. He’d believe it when he saw it. Granted, this could be regarded as the beginning of the region’s rainy season, but the last few years had come and gone with less rain than was needed to sustain an aquarium. Southern California was all but bone-dry. It would have taken very little to officially declare a drought.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At this point, the so-called rainy season was going the way of the unicorn and the dragon, myths for the very young.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sunshine was good for business, Trevor thought, but not for the land. When it rained, people tended to stay in their homes, or call for takeout rather than drive down to the beach to dine in a restaurant. Still, Trevor wished it would rain, at least for a little while. Parched brown was far from his favorite color.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Continuing to stare off into the horizon, his eyes narrowed. Was that some kind of a vessel silhouetted against the sky?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He squinted. He could have sworn he saw something large and white in the water.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A yacht?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or was that just his imagination? Not that he possessed much of one outside the boundaries of his kitchen. But stress could be making him see things that weren’t there.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get to bed, Trev, you’ve got a long day ahead of you tomorrow, remember?” he muttered. “Don’t go conjuring up things that aren’t there.” No one in their right mind would be sailing this time of night with a storm brewing. It had to be a trick of the light.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But even so, Trevor dawdled a minute longer, digging his bare feet into the sand, his shoes dangling from his fingertips. He supposed it was silly, but walking barefoot in the sand always made him feel like a kid again.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A kid with a hell of a lot of blessings to count, he reminded himself.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So why, with his life obviously so full, so busy that he didn’t have the time to draw in an unscheduled breath, with everything he ever wanted coming true, did he still feel as if something was missing from his life? As if there was supposed to be more, but wasn’t?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never satisfied, that’s your problem,” he murmured under his breath.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had no doubt that that would have been Travis’s assessment of the situation if he’d said anything to his brother. Travis was one of the two people with whom he shared not only his blood but also his face. He, Travis and Trent were born only minutes apart. Triplets so identical that for the first few years, not even his parents or his older brother, Mike, could tell them apart if not for a few identifying tricks his father had employed. He’d heard that his father had actually written their names on the soles of their left feet with a laundry marker until his mother had vetoed that practice.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they got older, he, Trent and Travis had taken full advantage of their communal looks, playing each other for the sole purpose of messing with everyone else’s minds.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sight of triplets tended to do that to people, he thought with a nostalgic smile. It reduced the public at large to confused masses. Entertained, he and his brothers had made the most of their situation—until their mother died in a plane crash and their world caved in.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t want to think about that now.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor shoved his free hand deep into his pocket. He didn’t want to think about anything, really, just make his mind a blank and recharge, that was the purpose behind this little Lawrence of Arabia trek across the cooling sand.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boardwalk, newly refurbished and running parallel to the sidewalk some fifty feet away, was right behind him. The car he’d driven to come down here this morning wasn’t much beyond that, in the restaurant’s parking lot. Trevor began to turn toward it, thinking that he needed to put his shoes back on and get home already, when something caught his eye.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a great deal closer than the vessel, which got smaller by the moment, off to whatever destination it had charted.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Closer and a lot less imposing.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t know if it was the moon highlighting it—whatever “it” was—or if some stray beam of light had caught on an object bobbing out in the waves.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, there was definitely something floating out there.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Probably driftwood or a giant hunk of seaweed, Trevor mocked himself.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or a shark.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a kid, he’d been terrified of the movie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jaws")]), _vm._v(" and all its sequels. So much so that even taking showers required preparatory silent pep talks on his part. For a whole year, he’d taken showers that lasted less than five minutes. His father had praised him for his efforts on behalf of conservation, but Kate knew the real cause. He’d been afraid that the water would attract the finny predator. Without saying anything to him directly, she’d made a point of taking him and his brothers on a field trip to the Aquarium of the Pacific in Long Beach as well as Sea World. Eventually, his phobia faded.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whatever was out there kept splashing.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sharks didn’t splash like that, he thought. What if it was a person?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What the hell would a person be doing in the middle of the water at this time of night? It didn’t make any sense.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But sense or not, his gut told him he was right. Someone was out there. Someone in trouble.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before he even completed the thought, Trevor found himself running to the edge of the water. He dropped his shoes and shrugged out of his jacket as he made his way into the waves.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey!” he shouted as loud as he could. “You need help out there?” It was a stupid question, but he wanted the person in the water to know that they weren’t alone. That help was coming.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no answer, only the sound of the waves reaching the shore. That, and another piercing announcement from a seagull.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The closer Trevor got to the edge of the water, the more convinced he was that a human being was out there.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t hesitate.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor dove into the water, fighting to keep his orientation foremost in his mind. He could easily lose his bearings out here in the water, especially in the dark. The water was warmer than he’d expected. Also rougher, but he was a strong swimmer, thanks to the lessons he and his brothers had taken. He could remember not wanting to, but Kate had insisted, saying he never knew when it might come in handy.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How right she was.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor struggled to keep his mouth closed as a wave washed over him, trying to pull him down. His shoulders protested against the effort. He couldn’t remember the last time he’d been swimming. His life left no room for things like that. He’d spent the last two years getting his restaurant on its feet and the five years before that either in college or the culinary academy.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was the one they’d made the nursery rhyme about, the one bemoaning Jack being all work and no play. The closest he’d come to “play” was when he got together with his parents, and his brothers and sister. They insisted he kick back, and he did, as much as he was able. But in his head, he was always working, always planning the next menu, the next banquet. He’d been hired for a number of those and his reputation, mercifully, was spreading by word of mouth.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Almost there!” he called out, trying not to gasp the words.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then, bobbing up and down in the swirling dark waters, he’d reached the person.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a woman.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The moment he was close to her, he saw her eyelashes flutter and then her eyes roll upward. Damn it, she was passing out. Was she hurt? How did she get here in the first place? Had she fallen off the yacht he’d thought he’d seen a few minutes ago?")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dozens of questions flew in and out of his brain like a bolt of lightning, yielding no answers. He grabbed at her before she could sink.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe it was better this way. If she was unconscious, at least she wouldn’t be flailing wildly with her arms or clutching at him to help keep her afloat. Either way she would have been a liability, endangering them both.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor looked toward the shore. God, but it seemed like a long distance away. Turning the unconscious woman so that she was floating on her back, he tucked one arm around her waist as best he could and used the other to swim.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was awkward at best and progress was slow. The waves seemed to be against him, pushing him back by half the distance he’d made.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It felt like an ongoing battle, one he couldn’t even begin to think about losing. No one knew he was out here. His family wouldn’t know what to think if all trace of him disappeared into the ocean.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He couldn’t do that to them.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Exhausted, he willed strength into his body, focusing on the shore and nothing else. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to reach it. Nothing else was an option.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It seemed as if it was taking forever.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His lungs were burning and his quadriceps felt as if they were on fire. He pressed on, tightening his hold on the woman.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time he finally reached the shore, his heart was racing, his head throbbing. He felt as if he’d swallowed a third of the ocean. Dragging her out and collapsing, he just lay there beside the woman he’d rescued, gasping for air, searching for precious equilibrium.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As his breathing returned to a normal rhythm, he realized that the woman beside him wasn’t making any noise. She wasn’t gasping, wasn’t wheezing or coughing.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wasn’t breathing at all.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning his head toward her, he noticed that her chest wasn’t rising and falling. She was as still as a dress-shop mannequin.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Damn it!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Scrambling to his knees, his own head spinning, Trevor struggled to remain upright as he began CPR. Again, he silently blessed Kate for her foresight because she had been the one to insist that they all—herself included—enroll in a class that taught CPR because “You never know when that kind of thing might come in handy.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d gone on to tease that if any of their pranks—far more subdued now that she was in their lives—would cause her heart to stop, they would at least know what to do.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t working. The woman wasn’t coming around, wasn’t breathing.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“C’mon, lady, I didn’t almost drown trying to save you just to have you die on me out here. Breathe, damn it, breathe!”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rather than give up, Trevor went at the compressions more forcefully. Breathing into her tilted mouth proved to be harder, because he had very little air to spare, but he doggedly continued, doing what he could, refusing to give up.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was going to breathe and that’s all there was to it.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t sure just how long he was there, pressing her chest and then blowing air into her mouth. “Forever” echoed in his mind.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just as his endurance splintered, the woman opened her eyes. The moment she did, a startled, wary look came into them.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reflecting back later, Trevor realized he should have guessed she’d be confused and scared. The woman had opened her eyes to find a man pressing his hands against her chest, his mouth hovering above hers, still damp with the imprint of her lips.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Coughing and spurting, the woman bolted upright, pushing him away. She scrambled back from him at the same time as her feet struggled for some kind of traction against the sand.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the hell do you think you’re doing?” she demanded hoarsely, her eyes wide with anger.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Saving your life,” he told her simply. Still on his knees, Trevor bent over farther, pushing her dark red hair away from her face.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Incensed, afraid and completely disoriented, she slapped away his hand. “Looks more like you’re trying to maul me,” she accused.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, he’d almost just drowned here, trying to save this woman’s life. He didn’t expect a ticker-tape parade, but a little civility would have been nice.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right,” he said, exhaling the word in exasperation. “I come out here every night, trolling for bodies riding on the waves, looking to cop a feel.” He rose to his feet, glaring at her. “You were drowning, lady. In case it escaped you, I just saved your life.” His voice grew colder, more sarcastic. “In lieu of a sizable donation to my favorite charity, a simple ‘thank you’ will suffice.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She frowned as she tried to get up to her feet. Her frown deepened when Trevor offered her his hand. She wanted to ignore it, but even she had to admit she was too wobbly to make it up on her own. Muttering, “Don’t try anything else,” she took the hand he extended.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But once on her feet, she began to sway again. Trevor caught her before she fell, automatically pulling her against him.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A displeased cry died on her lips as her eyes rolled back in her head for a second time.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was unconscious again.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor sighed and shook his head. “Second verse, same as the first.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Picking her up into his arms, he walked toward the nearest wooden bench and laid the woman down as gently as possible. He began to rub her wrists and arms, trying to get a little circulation going.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her dress was plastered to her body. Wet, it looked almost see-through. It obviously offered her very little protection against the escalating wind. It also left very little to his imagination.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had one hell of a body.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Trevor left her for a moment, hurrying off to where he’d dropped his jacket and shoes. He picked up both, then returned and covered her with his jacket. He checked the cell phone that had been in his pants pocket for the duration of his deep-sea adventure. Soggy, it had died. There was no calling for help.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He began rubbing her arms again. It was several minutes before she opened her eyes for a second time. Trevor braced himself for another waspish confrontation, but this time, she seemed too weak. Instead, she put her hand to her head, as if it was hurting. Squinting at him, he heard her say, “Name?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Trevor Marlowe,” he told her. “I—”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No—” impatience echoed in her frustrated, hoarse whisper “—mine.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17207d1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bridewithnonamethe_ch01.vue
// module id = 78
// module chunks = 0